export interface ZipInRadius {
  zcta: string;
  latitude: number;
  longitude: number;
  state: string | null;
  population: number;
  boundary: GeoJSON.Geometry | null;
  distance: number;
}

export interface ZipRadiusResult {
  zips: ZipInRadius[];
  summary: {
    total_zips: number;
    total_population: number;
    states_covered: string[];
  };
}

export async function getZipsInRadius(
  lat: number,
  lng: number,
  radius: number,
): Promise<ZipRadiusResult> {
  const apiBaseUrl = import.meta.env.VITE_SELFSERVICE_API_URL;
  if (!apiBaseUrl) {
    throw new Error('VITE_SELFSERVICE_API_URL is not set');
  }
  const params = new URLSearchParams({ lat: String(lat), lng: String(lng), radius: String(radius) });
  const res = await fetch(`${apiBaseUrl}/geographic/zips-in-radius?${params}`);
  if (!res.ok) {
    throw new Error(`zips-in-radius failed: ${res.status}`);
  }
  return res.json();
}

export interface GeocodedAddress {
  lat: number;
  lng: number;
  label: string;
}

export async function geocodeAddress(query: string): Promise<GeocodedAddress | null> {
  const token = import.meta.env.VITE_MAPBOX_TOKEN;
  if (!token) {
    throw new Error('VITE_MAPBOX_TOKEN is not set');
  }
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?country=US&types=address,place,postcode&limit=1&access_token=${token}`;
  const res = await fetch(url);
  if (!res.ok) return null;
  const data = await res.json();
  const feat = data.features?.[0];
  if (!feat) return null;
  return {
    lat: feat.center[1],
    lng: feat.center[0],
    label: feat.place_name || query,
  };
}
